<template>
  <div class="problemContainer">
    <div class="printArea">
      <el-button
        v-if="!approvalStatus"
        type="primary"
        @click="printClick()"
        icon="el-icon-printer"
        >打印</el-button
      >
    </div>
    <basicInfo :basicList="problemInfo"></basicInfo>
    <carinfo :carList="problemInfo"></carinfo>
    <faultInfo
      ref="faultRef"
      :faultList.sync="problemInfo"
      :authStatus="disabled"
    ></faultInfo>
    <problemDes
      ref="descRef"
      :problemDes.sync="problemInfo"
      :authStatus="disabled"
    ></problemDes>
    <imgVideo
      ref="imgVideoRef"
      :resourceInfo.sync="problemInfo"
      :authStatus="disabled"
    ></imgVideo>
    <recordInfo
      v-if="problemData.carType !== 0"
      :recordInfo="problemInfo"
    ></recordInfo>
    <additionalNotes
      ref="notesRef"
      :demandInfo.sync="problemInfo"
      :authStatus="disabled"
    ></additionalNotes>
    <approvalFlow :question-id="problemInfo.questionId"></approvalFlow>
    <approvalRecord :question-id="problemInfo.questionId"></approvalRecord>
    <postscript ref="postscript" :postscriptInfo="problemInfo"></postscript>
    <approvalOperation
      v-if="approvalStatus"
      :taskId="problemInfo.nowTaskId"
    ></approvalOperation>
  </div>
</template>
<script>
import "../../assets/css/qualityStyle.css";
import basicInfo from "./basicInfo.vue"; // 基本信息
import carinfo from "./carinfo.vue"; // 车型信息
import faultInfo from "./faultInfo.vue"; // 故障信息
import problemDes from "./problemDes.vue"; // 问题描述
import imgVideo from "./imgVideo.vue"; // 视频图片
import recordInfo from "./recordInfo.vue"; // 发动机变速器保养记录
import additionalNotes from "./additionalNotes.vue"; // 补充说明
import approvalFlow from "./approvalFlow.vue"; // 审批流程图
import approvalRecord from "./approvalRecord.vue"; // 审批记录
import postscript from "./postscript.vue"; // 附言
import approvalOperation from "./approvalOperation.vue"; //审批操作
import { getCurrentRoles, hasAnyRole } from "@/utils/role";
import printHtml from "../../util/qualityUtil/print.js";
export default {
  name: "problemIndex",
  components: {
    basicInfo,
    carinfo,
    faultInfo,
    problemDes,
    imgVideo,
    recordInfo,
    additionalNotes,
    approvalFlow,
    approvalRecord,
    postscript,
    approvalOperation,
  },
  props: {
    problemData: {
      type: Object,
      default: () => {},
    },
    viewOnly: {
      type: Boolean,
      default: false,
    },
  },
  provide() {
    return {
      getValidateForm: this.getValidateForm,
    };
  },
  data() {
    return {
      problemInfo: this.problemData,
      roleName: "",
      userRoles: [],
      disabled: true,
      approvalStatus: false,
    };
  },
  async created() {
    this.userRoles = getCurrentRoles();
    this.roleName = this.userRoles[0] || sessionStorage.getItem("role") || "";
    this.getFormAudit();
    this.scrollStatus();
    this.getApprovalStatus();
  },
  methods: {
    printClick() {
      const postscriptComponent = this.$refs.postscript;
      // 保存原始数据
      const originalPostscriptData = [...postscriptComponent.postscriptData];
      // 临时使用全部数据
      postscriptComponent.postscriptData = [
        ...postscriptComponent.postscriptArray,
      ];
      this.$nextTick(() => {
        // const fileName = `质量问题审核`
        // this.$exportPdf('claim-detail-content', fileName)
        let dom = document.createElement("div");
        let clonedContainer = $(".problemContainer").clone(true); // 克隆元素
        clonedContainer.find(".flex.operation_area .el-select").each(function() {
          const selectedText = $(this).find(".el-input__inner").val();
          const replacement = $(`<div class="printSelect">${ selectedText || ''}<i class="el-icon-arrow-down"></i></div>`);
          // 完全替换原元素
          $(this).replaceWith(replacement);
        });
        clonedContainer.find(".printArea, .approvalFlow, .postscript .fenye").remove();
        postscriptComponent.postscriptData = [...originalPostscriptData];
        $(dom).append(clonedContainer); // 添加到新DOM
        printHtml(dom.outerHTML);
      });
    },
    // 审批操作状态
    getApprovalStatus() {
      if (this.viewOnly) {
        this.approvalStatus = false;
        return;
      }
      if (hasAnyRole(["超级管理员", "质量数据查看"])) {
        this.approvalStatus = false;
        return;
      }
      if (this.problemData.taskStatus == 0) {
        this.approvalStatus = true;
      } else {
        this.approvalStatus = false;
      }
    },
    // 获取表单编辑权限
    getFormAudit() {
      if (this.viewOnly) {
        this.disabled = true;
        return;
      }
      if (hasAnyRole(["超级管理员", "质量数据查看"])) {
        this.disabled = true;
        return;
      }
      // 服务经理可修改数据
      const { userTaskId, taskStatus } = this.problemData;
      const { userRoles } = this;
      // 定义角色与允许的任务ID映射
      const rolePermissions = {
        服务经理: ["Activity_0wh76h6", "Activity_1r5u2c8"],
        PDI工程师: ["Activity_1lvb0jl"],
      };
      // 判断是否禁用
      this.disabled =
        taskStatus !== 0 ||
        !userRoles.some((r) => rolePermissions[r]?.includes(userTaskId));
    },
    // 滚动到审核操作
    scrollStatus() {
      setTimeout(() => {
        if ($(".approvalOperation")?.length > 0) {
          var mainTop = $(".main").offset().top;
          var approvalTop = $(".approvalOperation").offset().top;
          var approvalArea = $(".approvalOperation").outerHeight(true);
          var scrollVal = approvalTop + approvalArea - mainTop;
          $(".main").animate(
            {
              scrollTop: scrollVal,
            },
            100
          );
        }
      }, 100);
    },
    // 表单是否必填
    async getValidateForm() {
      const refs = ["faultRef", "descRef", "imgVideoRef", "notesRef"];
      // 并行验证所有表单
      const results = await Promise.all(
        refs.map((ref) => {
          const component = this.$refs[ref];
          return component?.validateForm?.() || { isValid: false, object: {} };
        })
      );
      const allValid = results.every((r) => r.isValid);
      if (!allValid) {
        const firstError = results.find((r) => !r.isValid);
        if (!this.getRequiredValid(firstError.isValid, firstError.object)) {
          return false;
        }
      }
      if (!this.getFileUploadTip()) {
        return false;
      }
      return allValid;
    },
  },
};
</script>
<style src="./problemDetail.css"></style>
